import * as React from 'react';
import styled from 'styled-components';
import BanaItem from '../../atoms/BanaItem';

const banas = [
  {
    link: '/speeches',
    img: '/images/thumbnails/speech.png',
    title: '卓話ライブラリー',
    desc: '過去の情報をご覧いただけます。',
  },
  {
    link: '/makeup',
    img: '/images/thumbnails/makeup.png',
    title: 'メークアップ',
    desc: '全国の例会会場をご案内',
  },
  {
    link: 'https://rid2750.org/',
    img: '/images/thumbnails/govener.png',
    title: 'ガバナー月信ー',
    desc: '毎月発行されるガバナーのメッセージや2750地区の活動報告',
  },
];
const BanaWrapper = styled.ul`
  & li {
    margin-bottom: 5px;
    line-height: 0;
  }
`;
// bana
const Bana = () => {
  return (
    <BanaWrapper>
      {banas.map((bana, i) => (
        <li key={i}>
          <BanaItem
            link={bana.link}
            img={bana.img}
            title={bana.title}
            desc={bana.desc}
          />
        </li>
      ))}
    </BanaWrapper>
  );
};

export default Bana;
